











import Vue from 'vue';

export default Vue.extend({
  name: 'Editor',
  props: {
    value: String,
  },
  data: () => ({
    content: '',
  }),
  watch: {
    value(newValue) {
      this.content = newValue;
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
  },
});
